// src/pages/nascar/TrucksPractice.jsx
import React from "react";
import NascarPracticePage from "../../components/NascarPracticePage";

export default function TrucksPractice() {
  const BASE = import.meta?.env?.BASE_URL ?? "/";

  return (
    <NascarPracticePage
      title="Trucks Practice Data"
      summarySrc={`${BASE}data/nascar/trucks/latest/practice_cons.json`}
      lapsSrc={`${BASE}data/nascar/trucks/latest/practice_laps.json`}
      showSources={false}
    />
  );
}
